module.exports = __webpack_public_path__ + "static/img/5.bcc8bdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/5.png
// module id = dfY3
// module chunks = 0